import { render } from "./Scarf_3_back.vue?vue&type=template&id=f9c0f0c8"
import script from "./Scarf_3_back.vue?vue&type=script&lang=js"
export * from "./Scarf_3_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__